import PartnershipDTO from "@/dto/partnership/PartnershipDTO";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import { groupBy } from "lodash";

interface RetailerOption {
    label: string;
    value: number;
}

interface RetailerOptionGroup {
    label: string;
    options: RetailerOption[];
}

function processPartnerships(partnerships: PartnershipDTO[], isCooperationSuspended: boolean) {
    const filteredRetailerPartnerships = partnerships.filter(({ suspended }) => suspended === isCooperationSuspended);

    return Object.values(groupBy(filteredRetailerPartnerships, (it) => it.shopType)).sort((a, b) => {
        const typeA = a[0]?.shopType;
        const typeB = b[0]?.shopType;

        if (typeA === "MANUAL" && typeB !== "MANUAL") {
            return 1;
        }

        if (typeA !== "MANUAL" && typeB === "MANUAL") {
            return -1;
        }

        return 0;
    });
}

function generateRetailerOptions(groupedRetailerPartnerships: PartnershipDTO[][]): RetailerOptionGroup[] {
    return groupedRetailerPartnerships
        .map((retailerPartnerships) => {
            const retailerShopType = retailerPartnerships[0]?.shopType;
            const options = retailerPartnerships
                .filter((partnership): partnership is PartnershipDTO & { shopId: number } => {
                    return typeof partnership.shopId === "number";
                })
                .map((partnership) => {
                    const retailerDisplayName = partnership.alias || partnership.name;

                    return {
                        label: retailerDisplayName,
                        value: partnership.shopId,
                    };
                });

            return {
                label: ShopTypeNameMap[retailerShopType],
                options,
            };
        })
        .filter((groupOption) => groupOption.options.length);
}

export function getRetailerFieldOptions(partnerships: PartnershipDTO[]) {
    const suspendedPartnershipsGroups = processPartnerships(partnerships, true);
    const activePartnershipsGroups = processPartnerships(partnerships, false);

    return {
        suspendedPartnershipsOptions: generateRetailerOptions(suspendedPartnershipsGroups),
        activePartnershipsOptions: generateRetailerOptions(activePartnershipsGroups),
    };
}
